import { makeAutoObservable, runInAction } from 'mobx';
import type { RootStore } from './root-store';
import { PersonalAssetHistoryMobxDto } from '../mobx/dtos/personal-assets/personal-asset-history-mobx-dto';
import { PersonalAssetWithValueMobxDto } from '../mobx/dtos/personal-assets/personal-asset-with-value-mobx-dto';

/**
 * InvestownAssetHistoryStore – dočasně napojen na stejná data jako PersonalAssetHistoryStore.
 */

export class InvestownAssetHistoryStore {
    rootStore: RootStore;

    investownAsset: PersonalAssetWithValueMobxDto;

    latestDate?: Date;

    investownAssetHistories: PersonalAssetHistoryMobxDto[] = [];

    limit = Number(process.env.NEXT_PUBLIC_PAGE_LIMIT);

    totalCount = 0;

    page = 1;

    loading = false;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this, {
            rootStore: false,
        });
    }

    startLoading(): void {
        this.loading = true;
    }

    stopLoading(): void {
        this.loading = false;
    }

    async fetchInvestownAsset(id: string): Promise<void> {
        // Dočasně používá stejný endpoint jako PersonalAssetHistoryStore
        this.startLoading();
        const [fetchedPersonalAsset, fetchedPersonalAssetHistoryList] = await Promise.all([
            this.rootStore.apiClient.personalAssetsApi.personalAssetControllerGet({
                id,
            }),
            this.rootStore.apiClient.personalAssetsHistoryApi.personalAssetHistoryControllerGetList({
                personalAssetId: id,
                limit: this.limit,
                offset: (this.page - 1) * this.limit,
            }),
        ]);
        runInAction(() => {
            this.investownAsset = PersonalAssetWithValueMobxDto.create(fetchedPersonalAsset);
            const { items, latestDate } = PersonalAssetHistoryMobxDto.createFromArray(
                fetchedPersonalAssetHistoryList.items,
            );
            this.investownAssetHistories = items;
            this.latestDate = latestDate;
            this.totalCount = fetchedPersonalAssetHistoryList.total;
            this.stopLoading();
        });
    }

    setPage(page: number, investownAssetId: string): void {
        this.page = page;
        this.fetchInvestownAsset(investownAssetId);
    }

    setPageLimit(limit: number | string | null, investownAssetId: string): void {
        if (limit && !Number.isNaN(limit)) {
            this.limit = +limit;
            this.setPage(1, investownAssetId);
        }
    }

    get pagesCount(): number {
        return Math.ceil(this.totalCount / this.limit) || 0;
    }
}
